interface IColumn {
  title: string;
  field: string;
  show: boolean;
  alwaysVisible: boolean;
  filter?: 'boolean' | 'numeric' | 'text' | 'date' | undefined;
  minWidth?: number;
  minGridWidth?: number;
  locked?: boolean;
  width?: string | number;
  noColumnMenu?: boolean;
  notFilterable?: boolean;
  twoFilterCriteria?: boolean;
  cell?: React.FC<any>;
  orderIndex?: number;
}
export const SelectivityTemplateMaintenanceGridColumns: IColumn[] = [
  {
    field: 'name',
    title: 'Template Name',
    show: true,
    alwaysVisible: true,
  },
  {
    field: 'inclusionOperator',
    title: 'Inclusion',
    width: '350px',
    show: true,
    alwaysVisible: true,
  },
  {
    field: 'criteriaCount',
    title: '# of Criteria',
    show: true,
    alwaysVisible: true,
  },
  {
    field: 'sysPrinCount',
    title: '# of Sys-Prins',
    show: true,
    alwaysVisible: true,
  },
  {
    field: 'lastUpdatedBy',
    title: 'Last Updated By',
    show: true,
    alwaysVisible: true,
  },
  {
    field: 'lastUpdated',
    title: 'Last Updated',
    filter: 'date',
    show: true,
    alwaysVisible: true,
  },
];
